import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useRef } from 'react';
import cn from 'classnames';
import { Button } from 'components/Button';
import styles from 'components/Modal/Modal.scss';

export const Modal = ({ className, isOpen, setIsOpen, children }) => {
  const modalRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, setIsOpen]);

  return (
    <>
      <div className={cn(styles.overlay, { [styles.active]: isOpen })}></div>
      <div className={cn(styles.modal, className, { [styles.active]: isOpen })} ref={modalRef}>
        <div className={styles.modalWrapper}>
          <Button className={styles.closeBtn} onClick={() => setIsOpen(false)} roundStyle no3D>
            <FontAwesomeIcon icon={faXmark} />
          </Button>
          {children}
        </div>
      </div>
    </>
  );
};
